<template>
	<v-menu offset-y>
		<template #activator="{ on, attrs }">
			<v-badge
				class="unread-badge"
				:style="{ '--badge-text-color': contrastColorOnPrimary }"
				:content="unreadcount"
				:value="unreadcount"
				color="primary"
				bottom
				overlap
				bordered
			>
				<v-btn color="accent" :class="['mr-4', 'button-block', 'font-weight-bold', contrastOnAccent]" depressed width="100%" v-bind="attrs" v-on="on">
					<v-icon :color="contrastColorOnAccent"> mdi-chat </v-icon>
				</v-btn>
			</v-badge>
		</template>
		<v-list>
			<v-list-item v-for="(unreadChat, index) in unreadChats" :key="index" @click="openMessageDialog(unreadChat.sentByID, unreadChat.receivedByID, unreadChat.name)">
				<!-- <v-list-item-icon width="60" height="60">
					<v-skeleton-loader v-if="!unreadChat[index].avatar" type="avatar" :loading="true" width="60" height="60"> </v-skeleton-loader>
					<v-img v-else-if="unreadChat[index].avatar" :src="unreadChat[index].avatar"></v-img>
				</v-list-item-icon> -->
				<div class="unreadItems">
					<v-list-item-title
						><strong>{{ unreadChat.name }}</strong></v-list-item-title
					>
					<v-avatar color="primary" size="20">
						<span :class="['text-subtitle-2', contrastOnPrimary]">{{ unreadChat.count }}</span>
					</v-avatar>
				</div>
			</v-list-item>
		</v-list>
	</v-menu>
</template>
<script>
import axios from 'axios';
import { bus } from '@/main';
import store from '@/store';
import { mapActions } from 'vuex';
export default {
	name: 'UnreadMessages',

	props: {
		unreadcount: Number,
	},

	data: () => ({
		no_avatar: store.getters.noAvatar,
		avatar: false,
		unreadChats: {},
	}),

	computed: {
		company: () => store.getters.company,

		user() {
			return store.getters.user || {};
		},
	},

	watch: {
		avatar() {
			this.renderKey += 1;
		},
	},

	async mounted() {
		await this.getUnreadMessageChats();
	},

	methods: {
		...mapActions('message', ['GetUnreadChats']),

		async getUnreadMessageChats() {
			const unreadConversations = await this.GetUnreadChats({
				receivedByID: this.user.locale === 'company' ? this.company.id : this.user.id,
			});
			this.unreadChats = unreadConversations;
		},

		async getAvatar(id) {
			const token = store.getters.jwtToken;
			let avatar;
			await axios
				.get(store.getters.getDOCUMENTS + '/images/avatar/' + id, { headers: { Authorization: token } })
				.then(response => {
					avatar = 'data:image/png;base64,' + response.data.data;
				})
				.catch(() => {
					avatar = 'no-avatar';
				});
			return avatar;
		},

		async openMessageDialog(sentByID, receivedByID, name) {
			for (let i = 0; i < this.unreadChats.length; i++) {
				if ((this.unreadChats[i].sentByID = sentByID)) {
					this.unreadChats.splice(i, 1);
				}
			}
			let receiverDetails = {
				id: sentByID,
				name,
			};
			bus.$emit('show-message-dialog', receiverDetails, receivedByID);
			this.unreadMessageCount = 0;
		},
	},
};
</script>
<style>
.unreadItems {
	gap: 1rem;
	display: flex;
	justify-content: space-between;
}
</style>
<style scoped>
.unread-badge ::v-deep .v-badge__badge {
	color: var(--badge-text-color, #ffffff) !important;
}
</style>
